/* eslint-disable array-callback-return */
/* eslint-disable radix */
import React from 'react';
import TagManager from 'react-gtm-module';
import generateSchemaOrg from '@core_modules/product/helpers/schema.org';
import Backdrop from '@common_backdrop';
import Layout from '@layout';
import Error from 'next/error';
import { getLocalStorage, setLocalStorage } from '@helper_localstorage';
import { StripHtmlTags } from '@helper_text';
import { useRouter } from 'next/router';
import { getProduct, getSeller, getPriceInstallmentLazy } from '@core_modules/product/services/graphql';
import { getLoginInfo } from '@root/core/helpers/auth';
import { setInvolveAsiaCookie, getCookiesSingle } from '@helper_cookies';
import useInvolveAsiaCampaign from '@hook/useInvolveAsiaCampaign';
import { getBrands } from '@core_modules/catalog/services/graphql';
import { brandNamePlaceholder } from '@helpers/env';
import { visitorIdCookie, admitadUidCookie } from '@config';

const ContentDetail = ({
    t, slug, product, keyProduct, Content, storeConfig, ssrProduct, isLogin, isPdp, dataBrands = {},
    // admitadUid = '', admitadCampaignCode = '', admitadPostbackKey = '',
}) => {
    const { clickId, utmSource, utmMedium } = useInvolveAsiaCampaign();
    const item = product && product.items ? product.items[keyProduct] : null;

    const { data: dSeller, loading: loadSeller } = getSeller({
        fetchPolicy: 'no-cache',
        variables: {
            input: {
                seller_id: item ? [parseFloat(item.seller_id)] : [],
            },
        },
        skip: !item,
    });

    const [getInstallmentPrice, { data: dataInstallmentPrice, loading: loadingInstallmentPrice }] = getPriceInstallmentLazy({
        fetchPolicy: 'no-cache',
    });

    const reviewValue = item ? parseInt(item.review.rating_summary, 0) / 20 : 0;

    React.useEffect(() => {
        if (clickId !== null || utmSource !== null || utmMedium !== null) {
            setInvolveAsiaCookie(clickId, utmSource, utmMedium);
        }
    }, [clickId, utmSource, utmMedium]);

    React.useEffect(() => {
        if (item) {
            getInstallmentPrice({
                variables: {
                    sku: product?.items[0]?.sku,
                },
            });
        }
    }, [item]);

    React.useEffect(() => {
        if (dataBrands && item) {
            let categoryProduct = '';
            let categoryOne = '';
            // eslint-disable-next-line no-unused-expressions
            item.categories.length > 0
            && ((categoryOne = item.categories[0].name),
            item.categories.map(({ name }, indx) => {
                if (indx > 0) categoryProduct += `/${name}`;
                else categoryProduct += name;
            }));
            // Brand of product
            const brand_name = dataBrands?.getBrandList?.items?.find((brand) => brand.attribute_id === item.brand)?.name || brandNamePlaceholder();
            // GTM UA dayaLayer
            const tagManagerArgs = {
                dataLayer: {
                    pageName: item.name,
                    pageType: 'product',
                    ecommerce: {
                        detail: {
                            product: [
                                {
                                    name: item.name,
                                    brand: brand_name,
                                    id: item.sku,
                                    price: item.price_range.minimum_price.regular_price.value || 0,
                                    category: categoryProduct,
                                    dimensions4: item.stock_status,
                                    dimensions5: reviewValue,
                                    dimensions6: item.review.reviews_count,
                                    dimensions7: item.sale === 0 ? 'NO' : 'YES',
                                },
                            ],
                        },
                        currencyCode: item.price_range.minimum_price.regular_price.currency || 'USD',
                    },
                    event: 'impression',
                    eventCategory: 'Ecommerce',
                    eventAction: 'Impression',
                    eventLabel: item.name,
                },
            };

            // GA 4 dataLayer
            const tagManagerArgsGA4 = {
                dataLayer: {
                    pageName: item.name,
                    pageType: 'product',
                    ecommerce: {
                        items: [
                            {
                                item_name: item.name,
                                item_brand: brand_name,
                                item_id: item.sku,
                                price: item.price_range.minimum_price.regular_price.value || 0,
                                item_category: categoryOne,
                                currency: item.price_range.minimum_price.regular_price.currency || 'USD',
                                item_stock_status: item.stock_status,
                                item_reviews_score: reviewValue,
                                item_reviews_count: item.review.reviews_count,
                                item_sale_product: item.sale === 0 ? 'NO' : 'YES',
                            },
                        ],
                    },
                    event: 'view_item',
                },
            };
            // Clear the previous ecommerce object.
            TagManager.dataLayer({ dataLayer: { ecommerce: null } });
            TagManager.dataLayer(tagManagerArgs);
            // Clear the previous ecommerce object.
            TagManager.dataLayer({ dataLayer: { ecommerce: null } });
            TagManager.dataLayer(tagManagerArgsGA4);

            // Postback Admitad
            // const admitadVariables = {
            //     campaignCode: admitadCampaignCode,
            //     postbackKey: admitadPostbackKey,
            //     uid: admitadUid, // This should match the value stored in the admitad_uid cookie
            //     orderId: `viewproduct_${item.sku}`,
            //     paymentType: 'lead', // sale || lead
            //     productId: item.sku,
            //     postback: '1',
            //     price: item.price_range.minimum_price.regular_price.value || 0,
            // };

            // const params = new URLSearchParams({
            //     ...admitadVariables,
            // });

            // if (admitadUid) {
            //     fetch(`/api/admitad-postback?${params.toString()}`);
            // }
        }
    }, [dataBrands, item]);

    const breadcrumbsData = React.useMemo(() => {
        if (typeof window !== 'undefined' && item) {
            let breadCrumbResult = [];
            if (item?.mageworx_breadcrumbs && item?.mageworx_breadcrumbs?.length > 0) {
                breadCrumbResult = item?.mageworx_breadcrumbs?.map((bc) => ({
                    label: bc.label,
                    link: `${bc.link}`,
                    active: false,
                    id: bc.category_id,
                }));
            }
            breadCrumbResult.push({
                label: item.name,
                link: '#',
                active: true,
            });
            return breadCrumbResult;
        }
        return [];
    }, [item]);

    if (!item) {
        return null;
    }

    let enableMultiSeller = false;
    if (storeConfig) {
        enableMultiSeller = storeConfig.enable_oms_multiseller === '1' || storeConfig.enable_oms_multiseller === 1;
    }

    let dataSeller;
    if (!loadSeller && dSeller && enableMultiSeller) {
        dataSeller = dSeller.getSeller;
    }

    return (
        <Content
            // product detail action
            t={t}
            product={product}
            productKey={keyProduct}
            slug={slug}
            isLogin={isLogin}
            storeConfig={storeConfig}
            // product detail
            breadcrumbsData={breadcrumbsData}
            dataSeller={dataSeller}
            ssrProduct={ssrProduct}
            isPdp={isPdp}
            dataInstallmentPrice={dataInstallmentPrice}
            loadingInstallmentPrice={loadingInstallmentPrice}
            dataBrands={dataBrands}
        />
    );
};

const PageDetail = (props) => {
    const {
        t, slug, Content, CustomHeader, storeConfig, ssrProduct, ssrProductData,
    } = props;

    const { admitad_campaign_code, admitad_postback_key } = storeConfig;

    const visitor_id = getCookiesSingle(visitorIdCookie);
    const admitadUid = getCookiesSingle(admitadUidCookie);

    const isLogin = getLoginInfo();

    const { data: dataBrands } = getBrands({ pageSize: 100, currentPage: 1 });

    /**
     * Check if partial data exists, AKA being navigated from a PLP or search page.
     */
    const router = useRouter();
    const routePaths = router.asPath.substr(1);
    const routeKey = routePaths.split('?');
    const routeKeyFilter = routeKey.length > 0 ? routeKey[0].replaceAll('#', '') : null;
    const productProps = router.query.productProps ? JSON.parse(router.query.productProps) : {};
    const productVariables = {
        variables: {
            url: slug[0],
            ...visitor_id && { visitor_id: parseInt(visitor_id, 10) },
        },
    };

    const { loading, data, error } = getProduct(storeConfig, { ...productVariables });

    const isLoadingPDP = error || (loading && !ssrProductData) || (!data && !ssrProductData);
    let isError = false;
    let errorMessage = '';
    if (error?.graphQLErrors && error?.graphQLErrors?.length > 0) {
        isError = true;
        errorMessage = error?.graphQLErrors[0]?.message;
    }

    const product = React.useMemo(() => {
        let productResult = {};
        let temporaryArr = [];
        let productByUrlMemo;
        if (data) {
            productResult = data.products;
            if (Object.keys(productProps).length > 0) {
                for (let i = 0; i < productResult.items.length; i += 1) {
                    if (routeKeyFilter === productResult.items[i].url_key) {
                        productByUrlMemo = [i];
                    }
                }
                productResult = {
                    ...productResult,
                    items: [
                        {
                            ...productResult.items[productByUrlMemo],
                        },
                    ],
                };
            }
            if (typeof window !== 'undefined') {
                if (productResult.items.length > 0) {
                    for (let i = 0; i < productResult.items.length; i += 1) {
                        if (routeKeyFilter === productResult.items[i].url_key) {
                            productByUrlMemo = [i];
                        }
                    }
                    const item = productResult.items[productByUrlMemo];
                    let isExist = false;
                    const viewedProduct = getLocalStorage('recently_viewed_product_pwa');

                    if (viewedProduct) {
                        temporaryArr = viewedProduct;
                        if (viewedProduct.length > 0) {
                            viewedProduct.map((val) => {
                                if (val.url_key === item?.url_key) {
                                    isExist = true;
                                }
                                return null;
                            });
                        }
                    }
                    if (isExist === false) {
                        temporaryArr = [];

                        const newItem = {
                            url_key: item?.url_key,
                        };
                        temporaryArr.push(newItem);
                        setLocalStorage('recently_viewed_product_pwa', temporaryArr);
                    }
                }
            }
        }

        return productResult;
    }, [data, productProps]);

    const productByUrl = React.useMemo(() => {
        let productByUrlResult;
        if (product?.items) {
            for (let i = 0; i < product.items.length; i += 1) {
                if (routeKeyFilter === product.items[i].url_key) {
                    productByUrlResult = [i];
                }
            }
        }
        return productByUrlResult;
    }, [product]);

    if (isError) {
        return (
            <Layout pageConfig={{}} CustomHeader={CustomHeader ? <CustomHeader /> : <></>} {...props}>
                <div className="product-detail-error">{errorMessage}</div>
            </Layout>
        );
    }

    if (isLoadingPDP) {
        return (
            <Layout pageConfig={{}} CustomHeader={CustomHeader ? <CustomHeader /> : <></>} {...props}>
                <Backdrop open />
            </Layout>
        );
    }

    const hasProductData = (product?.items?.length > 0) || (ssrProductData?.products?.items?.length > 0);

    if (!hasProductData) {
        return <Error statusCode={404} />;
    }

    // Use SSR data if available, otherwise use client-side data
    const productData = data || ssrProductData;
    let productItems = [];
    let currentProduct = {};
    let productByUrlIndex = productByUrl; // Keep original index for fallback

    if (productData && productData.products && productData.products.items) {
        productItems = productData.products.items;
        // During SSR, we need to find the product by URL key since productByUrl might not be set yet
        if (ssrProductData && !data) {
            // SSR mode: find product by URL key
            const targetUrlKey = slug[0];
            const foundIndex = productItems.findIndex((item) => item.url_key === targetUrlKey);
            if (foundIndex !== -1) {
                productByUrlIndex = foundIndex;
            }
        }
        currentProduct = productItems[productByUrlIndex] || {};
    } else if (product && product.items) {
        // Fallback to client-side data
        productItems = product.items;
        currentProduct = productItems[productByUrlIndex] || {};
    } else {
        // No product data available, create empty fallback
        currentProduct = {};
    }

    const schemaOrg = (product && product.items && product.items[productByUrl])
        ? generateSchemaOrg(product.items[productByUrl])
        : null; // Keep original for schemaOrg
    let keywords = {};
    if (currentProduct?.meta_keywords) {
        keywords = {
            type: 'meta',
            value: currentProduct?.meta_keywords,
        };
    }

    const config = {
        title: currentProduct.meta_title || currentProduct.name || '',
        bottomNav: false,
        header: 'absolute', // available values: "absolute", "relative", false (default)
        pageType: 'product',
        ogContent: {
            description: {
                type: 'meta',
                value: StripHtmlTags(currentProduct.meta_description || currentProduct.description?.html),
            },
            keywords,
            'og:image': currentProduct.small_image?.url,
            'og:image:type': 'image/jpeg',
            'og:description': StripHtmlTags(currentProduct.description?.html),
            'og:image:width': storeConfig?.pwa?.image_product_width,
            'og:image:height': storeConfig?.pwa?.image_product_height,
            'og:image:alt': currentProduct.name || '',
            'og:type': 'product',
            'product:availability': currentProduct.stock_status,
            'product:category':
                currentProduct.categories
                && currentProduct.categories.length > 0
                && currentProduct.categories[0].name,
            'product:condition': 'new',
            'product:price:currency': currentProduct.price_range?.minimum_price?.final_price?.currency,
            'product:price:amount': currentProduct.price_range?.minimum_price?.final_price?.value,
            'product:pretax_price:currency': currentProduct.price_range?.minimum_price?.final_price?.currency,
            'product:pretax_price:amount': currentProduct.price_range?.minimum_price?.final_price?.value,
            'og:title': currentProduct.meta_title || currentProduct.name,
        },
        schemaOrg,
        tagSelector: 'swift-page-pdp tablet:pb-0 mobile: pb-[50px] overflow-x-hidden',
    };

    return (
        <Layout isShowChat={false} pageConfig={config} CustomHeader={CustomHeader ? <CustomHeader /> : <></>} data={data} isPdp {...props}>
            <ContentDetail
                t={t}
                slug={slug[0]}
                keyProduct={productByUrl}
                product={product}
                ssrProduct={ssrProduct}
                Content={Content}
                isLogin={isLogin}
                storeConfig={storeConfig}
                isPdp
                dataBrands={dataBrands}
                admitadUid={admitadUid}
                admitadCampaignCode={admitad_campaign_code}
                admitadPostbackKey={admitad_postback_key}
            />
        </Layout>
    );
};

export default PageDetail;
